import { Link } from "react-router-dom";
import { Badge, Button, Group, Paper, Stack, Text } from "@mantine/core";
import type { LegacyCaseSummary } from "../../../types/legacyCases";
import { formatLegacyDate } from "../../../utils/legacyReviewForm";

const STATUS_LABELS = {
  archived: "Not reviewed",
  reviewed: "Draft saved",
  imported: "Imported",
};
const STATUS_COLORS = { archived: "gray", reviewed: "blue", imported: "green" };

export default function LegacyCaseListCard({
  item,
}: {
  item: LegacyCaseSummary;
}) {
  return (
    <Paper withBorder p="md">
      <Stack gap="sm">
        <Group justify="space-between">
          <Text fw={600}>{item.caseNumber}</Text>
          <Badge color={STATUS_COLORS[item.status]} variant="light">
            {STATUS_LABELS[item.status]}
          </Badge>
        </Group>
        <Text>
          {[item.firstName, item.middleInitial, item.lastName]
            .filter(Boolean)
            .join(" ") || "Patient name missing"}
        </Text>
        <Text size="sm">
          Date of birth: {formatLegacyDate(item.dateOfBirth)}
        </Text>
        <Text size="sm">Received: {formatLegacyDate(item.dateReceived)}</Text>
        <Text size="sm">
          {item.hasReport ? "Report available" : "Report missing"}
        </Text>
        {item.hasConflicts && (
          <Badge color="orange" variant="light">
            Source conflicts
          </Badge>
        )}
        <Button
          component={Link}
          to={`/admin/legacy-cases/${item.id}`}
          variant="light"
          fullWidth
        >
          Open {item.caseNumber}
        </Button>
      </Stack>
    </Paper>
  );
}
